import React from "react";

const IcEKYCOn = (props) => (
  <svg
    {...props}
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.1"
      cx={16}
      cy={16}
      r="15.5"
      fill="url(#paint0_linear)"
      stroke="url(#paint1_linear)"
    />
    <path
      d="M12.8889 9H10.5556C10.143 9 9.74733 9.16389 9.45561 9.45561C9.16389 9.74733 9 10.143 9 10.5556V12.8889M23 12.8889V10.5556C23 10.143 22.8361 9.74733 22.5444 9.45561C22.2527 9.16389 21.857 9 21.4444 9H19.1111M19.1111 23H21.4444C21.857 23 22.2527 22.8361 22.5444 22.5444C22.8361 22.2527 23 21.857 23 21.4444V19.1111M9 19.1111V21.4444C9 21.857 9.16389 22.2527 9.45561 22.5444C9.74733 22.8361 10.143 23 10.5556 23H12.8889"
      stroke="url(#paint2_linear)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="16.0631"
        y1="47.8106"
        x2="47.9369"
        y2="15.9369"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000790282" stopColor="#9000FF" />
        <stop offset="0.244875" stopColor="#8100E1" />
        <stop offset={1} stopColor="#005CEC" />
        <stop offset={1} stopColor="#005BEC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="16.0631"
        y1="47.8106"
        x2="47.9369"
        y2="15.9369"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000790282" stopColor="#9000FF" />
        <stop offset="0.244875" stopColor="#8100E1" />
        <stop offset={1} stopColor="#005CEC" />
        <stop offset={1} stopColor="#005BEC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="16.0276"
        y1="29.9172"
        x2="29.9724"
        y2="15.9724"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.000790282" stopColor="#9000FF" />
        <stop offset="0.244875" stopColor="#8100E1" />
        <stop offset={1} stopColor="#005CEC" />
        <stop offset={1} stopColor="#005BEC" />
      </linearGradient>
    </defs>
  </svg>
);

export default IcEKYCOn;
